import { render, staticRenderFns } from "./TratamientosPlanesInactivos.vue?vue&type=template&id=40b47393&scoped=true"
import script from "./TratamientosPlanesInactivos.vue?vue&type=script&lang=js"
export * from "./TratamientosPlanesInactivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b47393",
  null
  
)

export default component.exports